module.exports = __webpack_public_path__ + "img/967788c43b9d138aafa01f566924ba60.png";